import Skeleton from '@zenbusiness/zui/Skeleton';
import Stack from '@zenbusiness/zui/Stack';

import useBreakpoints from '#client/hooks/useBreakpoints';

import { ItemWrapper } from './ItemSkeleton.styles';

export default function ItemSkeleton() {
  const {
    sizes: { isDesktop }
  } = useBreakpoints();

  return (
    <ItemWrapper aria-label="item skeleton">
      <Stack
        direction="column"
        spacing="16px"
        width="100%"
      >
        <Stack
          alignItems="center"
          direction="row"
          display="flex"
          justifyContent="space-between"
          width="100%"
        >
          <Stack
            alignItems="center"
            direction="row"
            spacing="16px"
          >
            <Stack>
              <Skeleton
                height={isDesktop ? 44 : 40}
                variant="circular"
                width={isDesktop ? 44 : 40}
              />
            </Stack>
            <Stack
              alignItems="start"
              direction="column"
              spacing="4px"
            >
              <Skeleton
                height={isDesktop ? 44 : 40}
                width={isDesktop ? 160 : 110}
              />
            </Stack>
          </Stack>
          <Skeleton
            height={20}
            width={35}
          />
        </Stack>
      </Stack>
    </ItemWrapper>
  );
}
